export default () => ({

    costableType: null,
    costableId: null,
    tabId: null,
    isCostablePageLoading: false,
    isCostableTableLoading: false,
    costable: {
        contingency: {},
        cost_groups: [],
        totals: {},
        totals_per_guest: null,
        links: [],
        tabs: [],
        reported_information: {},
        costs_summary: {},
        resource_types: [],
        currencies: [],
        accepted_quote: {},
        is_editable: false,

        // These settings may be used across the site. We will eventually make a Settings module and hydrate it on initial vue load.
        // But for now, we store them here for convenience.
        // TODO move these outside of the costable; see CostableResource.
        settings: {
            is_duration_enabled: false,
            is_cost_bg_colour_enabled: false,
            unit_cost_column_colour: '',
            unit_price_column_colour: '',
            are_tabs_enabled: false,
            is_price_unit_enabled: false,
            should_open_pdfs_in_new_tab: false,
        },

    },

    filters: {
        type: null,
        status: null,
        reconciled: null,
        search: '',
        vatable: null,
        billable: null,
        user: null,
        transaction_type: null,
        secondary_status: null,
    },

    nextEditableUid: 0,

    settings: {},

    hiddenColumns: [],

    progress: null,
    progressIntervalId: null,
});
